module.exports = {
    'infw-root'               : 'px-widget',
    'infw-page'               : 'dls-accent-white-01-bg',
    'infw-caption-bar'        : 'row dls-accent-blue-02-bg dls-accent-white-01 pad-1-tb flex-align-center',
    'infw-caption-bar-inner'  : 'col-xs-10 col-md-10 col-lg-10 text-align-center',
    'infw-caption-text'       : 'heading-4 margin-0-b',
    'infw-message'            : 'col-md-12 margin-0-b text-align-center heading-3',

    'infw-message-wrapper'    : 'row margin',
    'infw-content'            : 'pad-1-t',
    'infw-content-container'  : 'row',

    'infw-footer'             : 'row pad margin-b',
    'infw-footer-help'        : '',
    'infw-footer-buttons'     : 'text-align-center',
    'infw-btn-desc'           : 'body-2 margin-lr-sm-up pad-2',

    // overlay & dialogs
    'infw-modal-wrapper'      : 'px-widget', 
    'infw-modal-overlay'      : '',
    'infw-dialog-frame'       : 'dls-accent-white-01-bg container-fluid text-align-center',
    'infw-dialog-title-bar'   : 'row dls-accent-white-01-bg dls-accent-blue-02 flex-align-center',
    'infw-dialog-title'       : 'col-md-10 col-md-offset-1 modal-title infw-dialog-title-font',
    'infw-dialog-body'        : 'card-body',
    'infw-dialog-icons'       : 'text-align-center',
    'infw-dialog-subtitle'    : 'heading-4',
    'infw-dialog-text'        : 'body-1',
    'infw-dialog-question'    : 'margin-0-b font-weight-bold',
    'infw-dialog-btn-box'     : 'card-foot pad-0-t row',
    'infw-dialog-btn-desc'    : 'infw-small-desc-13',
    
    'infw-small-desc'         : 'infw-small-desc-13',
    'infw-paragraph-padding'  : 'pad-1-b body-1',
    'infw-padding-30'         : 'pad-3',
    'infw-font-bold'          : 'font-weight-bold',
    'infw-pad-left'           : 'pad-1-2',
    "infw-section-desc"       : "body-1 text-align-left pad-tb",

    // buttons
    'infw-btn-primary'        : 'btn btn-block btn-block-center btn-primary',
    'infw-btn-secondary'      : 'btn btn-block btn-block-center btn-secondary',
    'infw-btn-primary-small'  : 'btn btn-primary btn-block-center btn-sm',
    'infw-btn-secondary-small': 'btn btn-secondary btn-block-center btn-sm',

    // icons
    'infw-icon-back-holder'   : 'col-xs-1 col-md-1 col-lg-1',
    'infw-icon-close-holder'  : 'col-xs-1 col-md-1 col-lg-1',

    'infw-icon-close'         : 'dls-icon-close icon-sm icon-hover',
    'infw-icon-right'         : 'dls-glyph-right',
    'infw-icon-left'          : 'dls-icon-left icon-sm',
    'infw-icon-down'          : 'dls-icon-down icon-sm',
    'infw-icon-warning'       : 'dls-icon-warning-filled dls-accent-red-01',
    'infw-icon-info'          : 'dls-icon-info dls-accent-blue-02',
    'infw-icon-check'         : 'dls-icon-check icon-sm dls-rewards-green-02',
    'infw-icon-success'       : 'dls-icon-success icon-sm pad-1-lr dls-rewards-green-02 font-weight-medium',
    'infw-icon-error'         : 'dls-icon-warning icon-sm pad-1-lr dls-accent-red-01 font-weight-medium',
    'infw-icon-remove'        : 'dls-icon-cancel-circle pad-1-lr icon-sm',

    // yodlee
    'infw-yodlee-how-section'    : '',
    'infw-yodlee-how-container1' : '',
    'infw-yodlee-how-container2' : 'container pad-2-tb',
    'infw-yodlee-how-container3' : 'text-align-center',
    'infw-list-text-rws'         : 'pad-1 heading-3 dls-core-blue-01',
    'infw-yodlee-how-subtitle'   : 'body-3',
    'infw-yodlee-how-icons-area' : 'infw-with-2-icons',
    'infw-yodlee-tnc-box'        : 'infw-tnc-box',
    'infw-yodlee-tnc-links'      : 'text-align-center',
    'infw-yodlee-tnc-confirm-container1'     : 'card-body',
    'infw-yodlee-tnc-confirm-container2'     : 'infw-hbox',
    'infw-yodlee-tnc-confirm-container-chk'  : '',
    'infw-yodlee-tnc-confirm-container-label': 'infw-small-desc',
    'infw-checkbox'              : 'infw-dls-checkbox margin-1-r',

    'infw-panel-content'      : 'flex-align-center border-dark-t pad dls-accent-gray-01-bg',
    'infw-link'               : '',
    'infw-link-help'          : '',

    'infw-single-box'         : 'single-box',
    'infw-accordion-header'   : 'collapsible flex-align-center text-align-left dls-accent-white-01-bg',
    'infw-accordion-content'  : 'accordion-content',
    'infw-accordion-border'   : 'accordion border-tb open',

    // LinkedIn
    'infw-linkedin-page'          : 'card',
    'infw-linkedin-how-container' : 'container',
    'infw-linkedin-how-title'     : 'infw-align-center heading-3 margin-2-tb',
    'infw-linkedin-how-section'   : 'infw-hbox infw-grey-border margin-1-b',
    'infw-linkedin-how-icons-area': 'infw-align-center dls-accent-gray-01-bg',
    'infw-linkedin-how-icon'      : 'icon-md dls-accent-blue-02',
    'infw-linkedin-how-text-area' : 'ls-accent-white-01-bg text-align-left pad-1',
    'infw-linkedin-how-text'      : 'heading-3 margin-1-tb',
    'infw-linkedin-how-desc'      : 'body-3',
    'infw-linkedin-tnc-box'       : 'infw-tnc-box',
    'infw-linkedin-tnc-links'     : 'pad-2-lr text-align-right',
    'infw-linkedin-tnc-confirm-box'  : 'infw-hbox pad-2-lr',
    'infw-linkedin-tnc-confirm-chk'  : 'infw-checkbox',
    'infw-linkedin-tnc-confirm-label': 'infw-small-desc',

    // FAQ
    'infw-faq-page'           : 'px-widget',
    'infw-faq-content'        : 'dls-accent-gray-02-bg pad-1',
    'infw-faq-title'          : 'heading-4 pad-1 dls-accent-white-01-bg',
    'infw-faq-item'           : 'text-align-left dls-accent-white-01-bg pad-1-t',
    'infw-faq-question'       : 'a margin-1',
    'infw-faq-answer'         : 'body-1 margin-1',
    'infw-faq-seeall'         : 'dls-accent-white-01-bg pad-1 margin-1-t'
};



// WEBPACK FOOTER //
// ./application/src/themes/default.js